var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 1.5C7.21442 1.5 5.95772 1.88122 4.8888 2.59545C3.81988 3.30968 2.98676 4.32484 2.49479 5.51256C2.00282 6.70028 1.87409 8.00721 2.1249 9.26809C2.3757 10.529 2.99477 11.6872 3.90381 12.5962C4.81285 13.5052 5.97104 14.1243 7.23192 14.3751C8.49279 14.6259 9.79973 14.4972 10.9874 14.0052C12.1752 13.5132 13.1903 12.6801 13.9046 11.6112C14.6188 10.5423 15 9.28558 15 8C14.9982 6.27665 14.3128 4.62441 13.0942 3.40582C11.8756 2.18722 10.2234 1.50182 8.5 1.5ZM11.3538 6.85375L7.85375 10.3538C7.80732 10.4002 7.75217 10.4371 7.69147 10.4623C7.63077 10.4874 7.56571 10.5004 7.5 10.5004C7.4343 10.5004 7.36923 10.4874 7.30853 10.4623C7.24783 10.4371 7.19269 10.4002 7.14625 10.3538L5.64625 8.85375C5.55243 8.75993 5.49972 8.63268 5.49972 8.5C5.49972 8.36732 5.55243 8.24007 5.64625 8.14625C5.74007 8.05243 5.86732 7.99972 6 7.99972C6.13268 7.99972 6.25993 8.05243 6.35375 8.14625L7.5 9.29313L10.6463 6.14625C10.6927 6.09979 10.7479 6.06294 10.8086 6.0378C10.8693 6.01266 10.9343 5.99972 11 5.99972C11.0657 5.99972 11.1308 6.01266 11.1915 6.0378C11.2521 6.06294 11.3073 6.09979 11.3538 6.14625C11.4002 6.1927 11.4371 6.24786 11.4622 6.30855C11.4873 6.36925 11.5003 6.4343 11.5003 6.5C11.5003 6.5657 11.4873 6.63075 11.4622 6.69145C11.4371 6.75214 11.4002 6.8073 11.3538 6.85375Z",
    fill: "#2DC26B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.074ed838d7b21d95750aaf75ddce06a5.svg";
export { ForwardRef as ReactComponent };